import { render, staticRenderFns } from "./selfCenterIndex.vue?vue&type=template&id=0a0d2f00"
import script from "./selfCenterIndex.vue?vue&type=script&lang=js"
export * from "./selfCenterIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports